import type {
	CustomItem,
	DropSlideshowType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropSlideshow = (
	item: Item | CustomItem
): item is DropSlideshowType => {
	return !!(item && item.__typename === 'Drop_Slideshow');
};
